module.exports = __webpack_public_path__ + "9c6153bd376a31edb844ad0e10819fd7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/surfboard.png
// module id = 1948
// module chunks = 0